import script from "./CTTP.vue?vue&type=script&setup=true&lang=js"
export * from "./CTTP.vue?vue&type=script&setup=true&lang=js"

import "./CTTP.vue?vue&type=style&index=0&id=be8537c8&lang=scss"

const __exports__ = script;

export default __exports__